
import { Device } from '@/store/types'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import PcHeader from './d-header.vue'
import MobileHeader from './m-header.vue'

@Options({
    inheritAttrs: false,
    components: {
        PcHeader,
        MobileHeader
    }
})
export default class HeaderView extends Vue {
    @Prop({ default: true }) isOnLoby!: boolean
    @Prop({ default: '' }) title!: string
    @Prop({ default: false }) isMultiView!: boolean
    @Prop({ default: 0 }) goodRoadCount!: number

    //#region Vuex
    @Getter('device') device!: Device
    //#endregion
}
